/**
 *  * Категория
 * Подкатегория
 * Тип
 * Серийник
 * Наименование
 * Сотрудник
 * user
 * worker
 * Срок годности
 * Файлы
 */

export function ItemModel(data) {
    const {
        cost,
        description,
        exp_date,
        exp_days,
        guid,
        id,
        inventoryFiles,
        manuf_date,
        model,
        name,
        purch_date,
        purch_place,
        type_uniform_id,
    } = data;

    return {
        cost,
        description,
        expirationDate: exp_date,
        expirationDays: exp_days,
        serialNumber: guid,
        id,
        files: (inventoryFiles || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        productionDate: manuf_date,
        model,
        name,
        purchaseDate: purch_date,
        purchasePlace: purch_place,
        type: type_uniform_id,
    };
}
